import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
export const generateUuid = () => webCrypto.randomUUID();
